<div class="measurements-overview" data-test="measurements-overview">
  <agr-table
    [config]="tableConfig"
    [emptyImage]="false"
    [emptyTitle]="'measurements.overview.empty-title' | translate"
    [emptyDescription]="'measurements.overview.empty-description' | translate"
  >
  </agr-table>
  <ng-template #typeColumn let-row="row">
    <div class="flex--row">
      <span>{{ 'measurements.types.' + row.type | translate }}</span>
    </div>
  </ng-template>

  <ng-template #rationTypeColumn let-row="row">
    <div class="flex--row">
      <span *ngIf="row.type === type.Product">
        {{ 'measurements.ration-types.roughage' | translate }}
      </span>

      <span *ngIf="row.type !== type.Product">
        {{ row.rationType ? ('measurements.ration-types.' + row.rationType | translate) : '' }}
      </span>
    </div>
  </ng-template>

  <ng-template #speciesColumn let-row="row">
    <div class="flex--row">
      <span>{{ row.species ? ('measurements.species.' + row.species | translate) : '' }}</span>
    </div>
  </ng-template>
</div>
